import * as React from "react";
import {ReactNode, useEffect, useState} from "react";
import ReactPaginate from 'react-paginate';
import "./pagination.scss"

interface IPagination {
    items: ReactNode[][] | []
    setCurrentItems: React.Dispatch<React.SetStateAction<ReactNode[][] | []>>;
    itemsPerPage: number
}

const Pagination = ({items, setCurrentItems, itemsPerPage}: IPagination) => {
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        let endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (event: { selected: number; }) => {
        let newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    };

    return (
        <div className="Pagination">
            <ReactPaginate
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="<"
                pageClassName="Pagination-Box-Item"
                pageLinkClassName="Pagination-Box-Link"
                previousClassName="Pagination-Box-Item"
                previousLinkClassName="Pagination-Box-Link"
                nextClassName="Pagination-Box-Item"
                nextLinkClassName="Pagination-Box-Link"
                breakLabel="..."
                breakClassName="Pagination-Box-Item"
                breakLinkClassName="Pagination-Box-Link"
                containerClassName="Pagination-Box"
                activeClassName="active"
                // @ts-ignore
                renderOnZeroPageCount={null}
            />
        </div>
    );
}

export default Pagination